module.exports = __webpack_public_path__ + "static/media/no-issues.f76140dc.svg";